import type { DiagramEdge, DiagramNode, LayoutMode } from '../core/types';
import type { LayoutPosition } from '../core/layout';

export type { LayoutMode } from '../core/types';
export type { LayoutPosition } from '../core/layout';

export function autoLayout(nodes: DiagramNode[], edges: DiagramEdge[], mode: LayoutMode): Promise<LayoutPosition[]> {
  if (nodes.length === 0) return Promise.resolve([]);
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL('../workers/layout.worker.ts', import.meta.url), { type: 'module' });
    const timeout = window.setTimeout(() => {
      worker.terminate();
      reject(new Error('Tempo limite do organizador automático excedido.'));
    }, 7000);

    worker.onmessage = (event: MessageEvent<LayoutPosition[]>) => {
      clearTimeout(timeout);
      worker.terminate();
      resolve(event.data);
    };
    worker.onerror = (error) => {
      clearTimeout(timeout);
      worker.terminate();
      reject(error);
    };
    worker.postMessage({ nodes, edges, mode, originX: 140, originY: 110, gap: 90 });
  });
}
